import { render, staticRenderFns } from "./MetadataPanel.vue?vue&type=template&id=86fe0274&scoped=true"
import script from "./MetadataPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MetadataPanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MetadataPanel.vue?vue&type=style&index=0&id=86fe0274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fe0274",
  null
  
)

export default component.exports